/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CwFormIcon = createIcon("CwFormIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#0E8367';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10V8h12v2h6v2h-6v2H18v-2h-6v-2h6Zm-6 2h2v24h-2V12Zm22 0h2v24h-2V12Zm2 24v2H12v-2h24Zm-6-6v2H18v-2h12Zm0-6v2H18v-2h12Zm0-6v2H18v-2h12Z",
    fill: _color
  }));
}, {
  "i18nKey": "svg.CwFormIcon",
  "replaceColor": true
});